import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Asset from './Asset';

import { AssetProps } from './Helpers';

import { FONT_VARIANT_CLASS_NAME } from '../../../../consts/consts';

export default class InfoHighlights extends Component {
  renderHighlight = ({
    id,
    class: highlightClass = '',
    images,
    header,
    copy,
    destinationPage,
    text,
  }) => {
    const image = (Array.isArray(images) && images.length && images[0]) || null;
    const { bodyFontSize } = this.props;
    const fontSizeClassName = FONT_VARIANT_CLASS_NAME[bodyFontSize || 'L'];

    return (
      <div className={`info-highlight ${highlightClass}`} key={id}>
        {image && (
          <div className="info-highlight__image-container">
            <Asset asset={image} outerWrapperClassName="info-highlight__image" />
          </div>
        )}
        <h3 className="info-highlight__header">{header}</h3>
        <p className={classNames('info-highlight__copy', fontSizeClassName)}>{copy}</p>
        <Link to={destinationPage.url} className="info-highlight__button button btn-terracotta">{text}</Link>
      </div>
    );
  };

  render() {
    const {
      anchor,
      header,
      links,
      points,
    } = this.props;

    if (!(Array.isArray(points) && Array.isArray(links))) {
      return null;
    }

    const highlights = points.map((point, index) => ({
      ...links[index],
      ...point,
    }));

    return (
      <div id={anchor || undefined} className="info-highlights">
        <h2 className="info-highlights__header">{header}</h2>
        {highlights.map(this.renderHighlight)}
      </div>
    );
  }
}

InfoHighlights.propTypes = {
  header: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    destinationPage: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  })),
  points: PropTypes.arrayOf(PropTypes.shape({
    class: PropTypes.string,
    header: PropTypes.string,
    copy: PropTypes.string,
    images: PropTypes.arrayOf(AssetProps),
  })),
};

InfoHighlights.defaultProps = {
  header: '',
  links: [],
  points: [],
};
